import { TransformType } from 'src/app/domainObjects/transformType';
import { DataTransform } from 'src/app/domainObjects/dataTransform';
import { TransformRule } from '../transformRule';
import { DataFarmType } from '../dataFarmType';
import { SortInfo } from '../sortInfo';
import { FindReplace } from '../rowExtractorTransform';
import { RuleType } from 'src/app/views/transform/transformerDetail/column-cleaner-transform-detail/columnCleanerViewModel';
import { AndOr, Criteria, DuplicateKeep, DuplicateType, FormatAs, Prepositions, RemoveOption } from 'src/app/views/transform/transformerDetail/column-cleaner-transform-detail/columnCleanerRuleViewModel';
import { Separator } from '../separator';

export class ColumnCleanerTransform extends DataTransform<ColumnCleanerTransformConfig> {

    constructor(id: number, index: number, name: string,nodeID:string) {
      super(id, name, index, TransformType.columnCleaner,nodeID);
      this.transformConfig = new ColumnCleanerTransformConfig();
    }

    static fromJSON(data: any): ColumnCleanerTransform {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnCleanerTransform = Object.assign(new ColumnCleanerTransform(0, 0, '', ''), data);
        if (instance.transformConfig) {
            instance.transformConfig = ColumnCleanerTransformConfig.fromJSON(instance.transformConfig);
        }

        return instance;
    }
    
    setRunAll(runAll: boolean): void {
        this.transformConfig.runAll = runAll;
    }
}

export class ColumnCleanerTransformConfig {
    transformConfigId?: number;
    instance: string;
    farmType: DataFarmType;
    transformType: TransformType;
    sortInfo?: SortInfo[];
    includeInResults?:string[];
    sampleStart: number;
    sampleEnd: number;
    runAll: boolean;
    threads: number;
    resetRows:boolean;
    findWildCard:string;
    
    rules: ColumnCleanerRule[];

    static fromJSON(data: any): ColumnCleanerTransformConfig {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnCleanerTransformConfig = Object.assign(new ColumnCleanerTransformConfig(), data);

        const rules: ColumnCleanerRule[] = [];
        if (instance.rules) {
            instance.rules.forEach(r => {
                const rule = ColumnCleanerRule.fromJSON(r);
                rules.push(rule);
            });
        }
        instance.rules = rules;
        return instance;
    }
}

export class ColumnCleanerRule extends TransformRule {
    ruleTypeIndex:number;
    ruleType : RuleType;
    fields: string[];
    conditionalFields: string[];
    criteria: Criteria;
    matchValue: string[][];
    ifMatched: boolean;
    andOr: AndOr;
    //keepRow: KeepRow;
    findReplace: FindReplace;
    matchAll: boolean;
    deleteWhenEmpty: number;
    separator: number;
    matchCase: boolean;
    targetField: string;
    emptyFieldValue: string;
    removeChars: string;
    keepOrigColumn: boolean;
    maxColumns: number; 
    colBaseName: string;
    noChars: number;
    startPos: number; 
    formatAs:FormatAs;
    duplicatesType: DuplicateType;
    duplicatesKeep: DuplicateKeep;
    moveColumns:FindReplace;
    overWriteData: boolean;
    articleOption: Prepositions;
    conjunctionOption: Prepositions;
    determinerOption: Prepositions;
    prepOption: Prepositions;
    removeOption:RemoveOption;

    static fromJSON(data: any): ColumnCleanerRule {
        //console.log(`fromJson invoked: ${data}`);
        const instance: ColumnCleanerRule = Object.assign(new ColumnCleanerRule(), data);

        return instance;
    }
}

export interface ColumnCleanerRuleStats {
    ruleIndex: number;
    rowsDeleted: number;
    rowsRemaining: number;
    valuesModified: number;
    groupHits: number;
}

export interface GlobalStats {
    rowsDeleted: number;
    rowsRemaining: number;
    valuesModified: number;
    groupHits: number;
}

export interface ColumnCleanerPreviewStats {
    globalStat: GlobalStats;
    ruleStats?: ColumnCleanerRuleStats[];
}

